// ブラウザを切り替えるコンポーネント.
import { detect } from 'detect-browser';
import { User } from '../../../constants/UserListField';
import { ResponseData } from '../../../constants/InterestCheck';
import React, { FC } from 'react';
import Edge from './Edge';
import Safari from './Safari';
import Default from './Default';
import Mobile from './Mobile';

import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// 興味関心チェックシート.
interface BrowserHandlerProps {
  user: User;
  interestCheck: ResponseData;
  loaded: boolean;
}

const BrowserHandler: FC<BrowserHandlerProps> = ({ user, interestCheck, loaded }) => {
  const theme = useTheme();
  const matches = {
    xs: useMediaQuery(theme.breakpoints.down('xs')),
    sm: useMediaQuery(theme.breakpoints.down('sm')),
  };
  const isMediaPrint = window.matchMedia('print');

  if (!isMediaPrint.matches && (matches.xs || matches.sm)) {
    return <Mobile user={user} interestCheck={interestCheck} loaded={loaded} />;
  }

  const browser = detect();
  if (browser) {
    const name: string = browser.name;
    switch (name) {
      case 'safari':
        return <Safari user={user} interestCheck={interestCheck} loaded={loaded} />;
      case 'edge':
        return <Edge user={user} interestCheck={interestCheck} loaded={loaded} />;
      default:
        // Firefox, Chrome共通.
        return <Default user={user} interestCheck={interestCheck} loaded={loaded} />;
    }
  }

  // 安全策.
  return <Default user={user} interestCheck={interestCheck} loaded={loaded} />;
};

export default BrowserHandler;
